import styled from "styled-components";
import { dFlexCenter, SHADOW_COLOR } from "../../../../../globalVariables/GlobalVariables";

export const conversionRates = styled.div`
   min-width: 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 1px;
    box-shadow: 0px 1px 4px ${SHADOW_COLOR}
`;
export const circle = styled.div`
    width:24px ;
    height:24px ;
    border-radius:50% ;
    ${dFlexCenter};
    font-size:12px ;
    font-weight:400 ;
    flex-direction:column ;
    line-height:8px ;
    padding-top:2px ;

`;
export const percent = styled.div`
    font-size:9px;
    font-weight: 600;
`;